import { userResource } from './resource'

export const userService = {
  whoami: (signal) => () => userResource.get('/who-am-i', { signal: signal() }),
  changePassword: (signal) => (data) =>
    userResource.post('/change-password', { ...data }, { signal: signal() })
}
